<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEmailFastOutline } from "@mdi/js";
export default {
  name: "MdiEmailFastOutline",
  data() {
    return {
      svgPath: mdiEmailFastOutline,
    };
  },
};
</script>
